import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { debugLogActions, debugErrorActions } from "../helpers/debugHelper";
import { RolesEnum } from "../types/RolesEnum";

const resolveRoleValue = (roleKey = "") => {
  const raw = (roleKey || "").trim();
  if (Object.values(RolesEnum).includes(raw)) {
    return raw;
  }
  const lower = raw.toLowerCase();
  if (lower === "manager" || lower === "specialist-manager") return RolesEnum.SPECIALIST_MANAGER;
  if (lower === "validator" || lower === "specialist-validator" || lower === "verificator" || lower === "specialist-verificator") return RolesEnum.SPECIALIST_VERIFICATOR;
  if (lower === "editor" || lower === "specialist-editor") return RolesEnum.SPECIALIST_EDITOR;
  if (lower === "pre-manager" || lower === "specialist-pre-manager") return RolesEnum.SPECIALIST_PRE_MANAGER;
  if (lower === "coordinator" || lower === "specialist-coordinator") return RolesEnum.SPECIALIST_COORDINATOR;
  if (lower === "liaison" || lower === "specialist-liaison" || lower === "enlace") return RolesEnum.SPECIALIST_LIAISON;
  return null;
};

const specialistSetRolesLoading = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_ROLES_LOADING,
  payload
});

const specialistSetRoles = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_ROLES,
  payload
});

const specialistSetPoolLoading = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_POOL_LOADING,
  payload
});

const specialistSetPool = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_POOL,
  payload
});

const specialistSetAssignedLoading = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_ASSIGNED_LOADING,
  payload
});

const specialistSetAssigned = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_ASSIGNED,
  payload
});

const specialistSetActionLoading = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_ACTION_LOADING,
  payload
});

const specialistSetError = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_ERROR,
  payload
});

const specialistSetMetricsLoading = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_METRICS_LOADING,
  payload
});

const specialistSetMetrics = (payload) => ({
  type: types.SPECIALIST_SELECTION_SET_METRICS,
  payload
});

const handleApiError = (body, dispatch) => {
  if (body?.code === "flow-engine-disabled") {
    Swal.fire(
      t("titles.error"),
      t("general.flow-engine.disabled-module", "Motor de flujos desactivado para este módulo. Active flow.engine.enabled y flow.engine.{modulo}.enabled en configuración."),
      "warning"
    );
    return;
  }
  if (body?.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
    return;
  }
  if (body?.code === "bak-aut-tok-inv-001" || body?.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
};

const buildPoolQuery = ({ page = 0, size = 10, searchText = "" }) => {
  const params = new URLSearchParams();
  const safePage = Number.isFinite(Number(page)) && Number(page) >= 0 ? Number(page) : 0;
  const safeSize = Number.isFinite(Number(size)) && Number(size) > 0 ? Number(size) : 10;
  params.append("page", safePage);
  params.append("size", safeSize);
  if (searchText) {
    params.append("search", searchText);
  }
  return params.toString();
};

export const startLoadingSpecialistRoles = () => {
  return async (dispatch) => {
    dispatch(specialistSetRolesLoading(true));
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_SELECTION}`,
        "role-selection"
      );
      const body = await resp.json();

      debugLogActions(":: specialistSelectionActions, startLoadingSpecialistRoles", { body });

      if (body.ok) {
        dispatch(specialistSetRoles(body.roles || []));
      } else {
        handleApiError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startLoadingSpecialistRoles", { error });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(specialistSetRolesLoading(false));
    }
  };
};

export const startLoadingSpecialistPool = ({
  roleKey,
  moduleName,
  page = 0,
  size = 10,
  searchText = ""
}) => {
  console.log("7777, startLoadingSpecialistPool", { roleKey, moduleName, page, size, searchText });
  return async (dispatch) => {
    if (!moduleName) {
      return;
    }
    console.log("7777, startLoadingSpecialistPool", { moduleName });
    const roleValue = resolveRoleValue(roleKey);
    console.log("7777, startLoadingSpecialistPool", { roleValue });
    if (!roleValue || !moduleName) {
      return;
    }
    console.log("7777, startLoadingSpecialistPool", { moduleName });
    const safePage = Number.isFinite(Number(page)) && Number(page) >= 0 ? Number(page) : 0;
    const safeSize = Number.isFinite(Number(size)) && Number(size) > 0 ? Number(size) : 10;

    dispatch(
      specialistSetPoolLoading({
        roleKey: roleValue,
        moduleName: moduleName.toLowerCase()
      })
    );

    try {

      const queryString = buildQuery({ page: safePage, size: safeSize, search: searchText });

      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_SELECTION}`,
        `${roleValue}/pool/${moduleName.toLowerCase()}${queryString}`
      );

      /*
      const queryString = buildPoolQuery({ page: safePage, size: safeSize, searchText });
      const endpoint = `${const_routes.ROUTE_SPECIALIST_SELECTION}/${roleValue}/pool/${moduleName.toLowerCase()}${queryString ? `?${queryString}` : ""}`;

      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        endpoint
      );
      */

      const body = await resp.json();

      debugLogActions(":: specialistSelectionActions, startLoadingSpecialistPool", {
        //endpoint,
        body
      });

      if (body.ok) {
        dispatch(
          specialistSetPool({
            roleKey: roleValue,
            moduleName: moduleName.toLowerCase(),
            data: body.pool || body.inbox || {},
            page: safePage,
            size: safeSize,
            searchText
          })
        );
      } else {
        handleApiError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startLoadingSpecialistPool", {
        error,
        roleKey,
        moduleName
      });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(
        specialistSetPoolLoading({
          roleKey: roleValue,
          moduleName: moduleName.toLowerCase(),
          loading: false
        })
      );
    }
  };
};

const buildQuery = ({ page, size, search }) => {
  const params = new URLSearchParams();
  if (Number.isFinite(page)) params.append("page", page);
  if (Number.isFinite(size)) params.append("size", size);
  if (search) params.append("search", search);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export const startAssignSpecialistCases = ({
  roleKey,
  moduleName,
  recordIds,
  targetUserId,
  targetMode,
  originManagerUserId,
  activeRoleKey
}) => {
  return async (dispatch) => {
    if (!moduleName) {
      return false;
    }
    const roleValue = resolveRoleValue(roleKey);
    if (!roleValue || !moduleName || !Array.isArray(recordIds) || recordIds.length === 0) {
      Swal.fire(t("titles.error"), t("specialist.selection.validation.records", "Selecciona al menos un registro"), "error");
      return false;
    }

    dispatch(specialistSetActionLoading({ action: "assign", status: true }));

    try {
      const payload = {
        moduleName: moduleName.toLowerCase(),
        recordIds,
        active_role_key: activeRoleKey || ""
      };
      if (String(targetMode || "").toLowerCase() === "pool") {
        payload.target_mode = "pool";
      } else if (targetUserId) {
        payload.target_user_id = Number(targetUserId);
      }
      if (originManagerUserId) {
        payload.origin_manager_user_id = Number(originManagerUserId);
      }

      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_SELECTION}`,
        `${roleValue}/assign`,
        payload,
        "POST"
      );
      const body = await resp.json();

      debugLogActions(":: specialistSelectionActions, startAssignSpecialistCases", {
        roleKey,
        moduleName,
        recordIds,
        body
      });

      if (body.ok) {
        Swal.fire(t("titles.success"), t("specialist.selection.assign.success", "Los registros fueron asignados correctamente"), "success");
        return true;
      }
      handleApiError(body, dispatch);
      return false;
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startAssignSpecialistCases", {
        error,
        roleKey,
        moduleName
      });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
      dispatch(
        specialistSetError({
          action: "assign",
          error: error?.message
        })
      );
      return false;
    } finally {
      dispatch(specialistSetActionLoading({ action: "assign", status: false }));
    }
  };
};

export const startPreviewReassignChain = ({
  roleKey,
  moduleName,
  recordIds,
  targetUserId,
  activeRoleKey
}) => {
  return async () => {
    const roleValue = resolveRoleValue(roleKey);
    if (!roleValue || !moduleName || !Array.isArray(recordIds) || !recordIds.length || !targetUserId) {
      return { origin_options: [], suggested_origin_manager_user_id: null };
    }

    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_SELECTION}`,
        `${roleValue}/reassign-preview`,
        {
          moduleName: moduleName.toLowerCase(),
          recordIds,
          target_user_id: Number(targetUserId),
          active_role_key: activeRoleKey || ""
        },
        "POST"
      );
      const body = await resp.json();
      if (body.ok) {
        return {
          origin_options: body.origin_options || [],
          suggested_origin_manager_user_id: body.suggested_origin_manager_user_id || null
        };
      }
      return { origin_options: [], suggested_origin_manager_user_id: null };
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startPreviewReassignChain", {
        error,
        roleKey,
        moduleName
      });
      return { origin_options: [], suggested_origin_manager_user_id: null };
    }
  };
};

export const startReleaseSpecialistCases = ({ roleKey, moduleName, recordIds, activeRoleKey }) => {
  return async (dispatch) => {
    if (!moduleName) {
      return false;
    }
    const roleValue = resolveRoleValue(roleKey);
    if (!roleValue || !moduleName || !Array.isArray(recordIds) || recordIds.length === 0) {
      Swal.fire(t("titles.error"), t("specialist.selection.validation.records", "Selecciona al menos un registro"), "error");
      return false;
    }

    dispatch(specialistSetActionLoading({ action: "release", status: true }));

    try {
      const payload = {
        moduleName: moduleName.toLowerCase(),
        recordIds,
        active_role_key: activeRoleKey || ""
      };

      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_SELECTION}/${roleValue}/release`,
        payload,
        "POST"
      );
      const body = await resp.json();

      debugLogActions(":: specialistSelectionActions, startReleaseSpecialistCases", {
        roleKey,
        moduleName,
        recordIds,
        body
      });

      if (body.ok) {
        Swal.fire(t("titles.success"), t("specialist.selection.release.success", "Los registros fueron liberados correctamente"), "success");
        return true;
      }
      handleApiError(body, dispatch);
      return false;
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startReleaseSpecialistCases", {
        error,
        roleKey,
        moduleName
      });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
      dispatch(
        specialistSetError({
          action: "release",
          error: error?.message
        })
      );
      return false;
    } finally {
      dispatch(specialistSetActionLoading({ action: "release", status: false }));
    }
  };
};

export const startLoadingSpecialistMetrics = ({ roleKey }) => {
  return async (dispatch) => {
    console.log("7777, startLoadingSpecialistMetrics", { roleKey });
    const roleValue = resolveRoleValue(roleKey);
    if (!roleValue) {
      return;
    }

    console.log("7777, startLoadingSpecialistMetrics", { roleValue });

    dispatch(specialistSetMetricsLoading(true));

    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_SPECIALIST_SELECTION}`,
        `${roleValue}/metrics`
      );
      const body = await resp.json();

      debugLogActions(":: specialistSelectionActions, startLoadingSpecialistMetrics", {
        roleKey,
        body
      });

      if (body.ok) {
        dispatch(
          specialistSetMetrics({
            roleKey: roleValue,
            modules: body.metrics || [],
            totals: body.totals || {
              overall: 0,
              pool: 0,
              assigned: 0,
              pending: 0,
              blocked: 0
            }
          })
        );
      } else {
        dispatch(
          specialistSetMetrics({
            roleKey: roleValue,
            modules: [],
            totals: {
              overall: 0,
              pool: 0,
              assigned: 0,
              pending: 0,
              blocked: 0
            }
          })
        );
        if (body?.code && body.code !== "bak-error-001") {
          handleApiError(body, dispatch);
        }
      }
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startLoadingSpecialistMetrics", {
        error,
        roleKey
      });
      dispatch(
        specialistSetMetrics({
          roleKey: roleValue,
          modules: [],
          totals: {
            overall: 0,
            pool: 0,
            assigned: 0,
            pending: 0,
            blocked: 0
          }
        })
      );
    } finally {
      dispatch(specialistSetMetricsLoading(false));
    }
  };
};

export const startLoadingSpecialistAssigned = ({
  roleKey,
  moduleName,
  page = 0,
  size = 20
}) => {
  return async (dispatch, getState) => {
    console.log("7777, startLoadingSpecialistAssigned", { roleKey, moduleName, page, size });
    const roleValue = resolveRoleValue(roleKey);
    if (!roleValue || !moduleName) {
      return;
    }
    const safePage = Number.isFinite(Number(page)) && Number(page) >= 0 ? Number(page) : 0;
    const safeSize = Number.isFinite(Number(size)) && Number(size) > 0 ? Number(size) : 20;

    dispatch(
      specialistSetAssignedLoading({
        roleKey: roleValue,
        moduleName: moduleName.toLowerCase()
      })
    );

    try {
      console.log("7777, startLoadingSpecialistAssigned", { moduleName, roleValue, page: safePage, size: safeSize });
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${moduleName.toLowerCase()}`,
        `inbox/${roleValue}/${safePage}/${safeSize}`
      );
      const body = await resp.json();
      console.log("7777, startLoadingSpecialistAssigned", { body });
      debugLogActions(":: specialistSelectionActions, startLoadingSpecialistAssigned", {
        roleKey,
        moduleName,
        body
      });

      if (body.ok) {
        const { user } = getState().auth;
        const currentUserId = user?.user_id;
        const rows = (body.inbox?.rows || body.inbox?.records || []).filter((record) => {
          return currentUserId ? record.current_user_id === currentUserId : true;
        });

        dispatch(
          specialistSetAssigned({
            roleKey: roleValue,
            moduleName: moduleName.toLowerCase(),
            rows
          })
        );
      } else {
        handleApiError(body, dispatch);
      }
    } catch (error) {
      debugErrorActions(":: specialistSelectionActions, startLoadingSpecialistAssigned", {
        error,
        roleKey,
        moduleName
      });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(
        specialistSetAssignedLoading({
          roleKey: roleValue,
          moduleName: moduleName.toLowerCase(),
          loading: false
        })
      );
    }
  };
};

